<template>
  <div class="row my-5">
    <div class="col-md-12">
      <ul
        class="nav nav-pills nav-fill"
        id="myTab"
        role="tablist"
        style="width:60%; margin: 0 auto;">
        <li class="nav-item" role="presentation">
          <button
            class="btn btn-outline-primary dealer-btn active my-2"
            id="expertise-tab"
            data-bs-toggle="tab"
            data-bs-target="#expertise"
            type="button"
            role="tab">
            <strong>EXPERTISE & SERVICE</strong>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="btn btn-outline-primary dealer-btn my-2"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#oneStop"
            type="button"
            role="tab">
            <strong>ONE-STOP-SHOPPING</strong>
          </button>
        </li>
      </ul>
      <!-- Tabs -->
      <div
        class="tab-content my-5"
        style="width:60%; margin: 0 auto;">
        <div
          class="tab-pane active"
          id="expertise"
          role="tabpanel">
          <div class="row">
            <!-- Dealer Image 1 -->
            <div
              class="col-md-6 text-center position-relative mb-3"
              :style="bg1"/>
            <div class="col-md-6 px-4">
              <p>Whether it be product knowlege, training, technical solutions, order and delivery coordination, or special order itmes, our team is devoted to improving your bottom line.</p>
            </div>
          </div>
        </div>
        <div
          class="tab-pane"
          id="oneStop"
          role="tabpanel">
          <div class="row">
            <!-- Dealer Image 2 -->
            <div
              class="col-md-6 text-center position-relative mb-3"
              :style="bg2"/>
            <div class="col-md-6 px-4">
              <p>With more than 14,000 stocked products from over 250 suppliers, we are committed to your success.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        bg1:{
          backgroundImage: `url(${require('../../../../../../assets/images/cheney/advantage/PXL_20240411_144711701.jpg')})`,
          ...this.bgProperties()
        },
         bg2:{
          backgroundImage: `url(${require('../../../../../../assets/images/cheney/advantage/PXL_20240411_145521230.jpg')})`,
          ...this.bgProperties()
        }
      }
    },
    methods:{
      bgProperties(){
        return {
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '350px'
        }
      }
    }
  }
</script>

<style scoped>
  .nav-pills .nav-link.active{
    color: white;
    background: var(--bs-success);
  }
  .dealer-btn{
    min-width: 225px;
  }
</style>